module.exports = __webpack_public_path__ + "607c3fdd445a2f6632749d6d8d323b22.reviews.svg";